export default __webpack_public_path__ + "static/media/type_08_drk@60.a21ac939.svg";